import classNames from 'classnames/bind';
import { gql } from '@apollo/client';
import styles from './AcfFeature.module.scss';
import { Image, Card, Heading, RichText } from '@/components';

let cx = classNames.bind(styles);

export default function AcfFeature(props) {
	const { feature, attributes } = props;
	const styles = feature?.styles || [];
	const className = attributes.className?.split(' ') || [];

	function CardContents({ id }) {
		return (
			<div id={id} className={cx(['feature', ...className, ...styles, feature.headingText && 'has-heading'])}>
        <div className={cx(['feature-container'])}>
				{feature.icon && (
					<div className={cx('icon-container')}>
						<Image image={feature.icon} fill={true} objectFit="contain" />
					</div>
				)}
				<div className={cx('text-container')}>
					{feature.headingText && (
						<Heading className={cx('feature-heading')} level={feature.headingElement || 'h3'}>
							{feature.headingText}
						</Heading>
					)}
					<RichText className={cx('feature-text-body')} html={feature.text} />
				</div>
        </div>
			</div>
		);
	}
	return (
		<>
			{styles.includes('card') ? (
				<Card id={attributes.anchor} outline={true} fullHeight={attributes.fullHeight}>
					<CardContents />
				</Card>
			) : (
				<CardContents id={attributes.anchor} />
			)}
		</>
	);
}

AcfFeature.fragments = {
	key: `AcfFeatureFragment`,
	entry: gql`
		${Image.fragments.entry}
		fragment AcfFeatureFragment on AcfFeature {
			attributes {
				anchor
				className
        fullHeight
			}
			feature {
				icon {
					...ImageFragment
				}
				headingText
				headingElement
				styles
				text
			}
		}
	`,
};

AcfFeature.config = {
	name: 'AcfFeature',
};
AcfFeature.displayName = 'AcfFeature';
